export default __webpack_public_path__ + "static/media/partnership.52df44f8.jpg";